import { useQuery } from "@tanstack/react-query";
import { PageLoader } from "components";
import queryString from "query-string";
import { client_v2 } from "utils/api";

const FindByExpanoPimId = ({ history, location }) => {
  const { expano_pim_id } = queryString.parse(location.search);

  useQuery(
    ["search", expano_pim_id],
    () => client_v2.get(`/products/find_by_expano_pim_id?expano_pim_id=${expano_pim_id}`),
    {
      select: (res) => res.data,
      retry: false,
      onSuccess: ({ id }) => {
        history.push(`/products/${id}/basic`);
      },
      onError: (err) => {
        console.log(err);
        history.push("/products");
      },
    }
  );
  return <PageLoader />;
};

export default FindByExpanoPimId;
